module.exports = __webpack_public_path__ + "img/7.5e247452.jpg";